import { invokeApi } from "../utils/api";
import { $axiosWithToken } from "../utils/axios";

export const addShirtCategory = (data) =>
    invokeApi($axiosWithToken, "/shirtcategories", data, "POST")
        .then((resp) => resp)
        .catch((err) => {
            throw err;
        });

export const deleteShirtCategory = (id) =>
    invokeApi($axiosWithToken, `/shirtcategories/${id}`, {}, "DELETE")
        .then((resp) => resp)
        .catch((err) => {
            throw err;
        });

export const getShirtCategories = () =>
    invokeApi($axiosWithToken, "/shirtcategories", {}, "GET")
        .then((resp) => resp)
        .catch((err) => {
            throw err;
        });

export const getSingleShirtCategory = (id) =>
    invokeApi($axiosWithToken, `/shirtcategories/${id}`, {}, "GET")
        .then((resp) => resp)
        .catch((err) => {
            throw err;
        });

export const updateShirtCategory = (id, data) =>
    invokeApi($axiosWithToken, `/shirtcategories/${id}`, data, "PUT")
        .then((resp) => resp)
        .catch((err) => {
            throw err;
        });
